export enum BerlinDistrictsEnum {
	CHWI = 'Charlottenburg-Wilmersdorf',
	FRKR = 'Friedrichshain-Kreuzberg',
	LICH = 'Lichtenberg',
	MAHE = 'Marzahn-Hellersdorf',
	MITT = 'Mitte',
	NEUK = 'Neukölln',
	PANK = 'Pankow',
	REIN = 'Reinickendorf',
	SPAN = 'Spandau',
	STZE = 'Steglitz-Zehlendorf',
	TSCH = 'Tempelhof-Schöneberg',
	TRKOE = 'Treptow-Köpenick',
}
